import React from 'react'

import { ArrowLeft, Info } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { WidgetId } from '../../Constants/WidgetConfig'
import { getWidgetDescription } from '../../Constants/WidgetDescriptions'

interface IWorkflowData {
  id?: string
  title: string
  categoryName: string
  status: string
  startDate: string | number
}

interface ITableWidgetProps {
  widgetId: WidgetId
  title: string
  workflows: IWorkflowData[]
  isFlipped: boolean
  onFlip: (widgetId: string, e: React.MouseEvent) => void
}

const TableWidget: React.FC<ITableWidgetProps> = ({
  widgetId,
  title,
  workflows,
  isFlipped,
  onFlip,
}) => {
  const description = getWidgetDescription(widgetId)

  const content = (
    <div className="widget table-widget">
      <div className="widget-header">
        <span className="widget-title">{title}</span>
        <Button
          variant="ghost"
          size="icon"
          onClick={e => onFlip(widgetId, e)}
          onMouseDown={e => e.stopPropagation()}
          title={Localization.translator.dashboard.widgetInfo}
        >
          <Info />
        </Button>
      </div>
      <div className="widget-body">
        <div className="workflow-table">
          <div className="table-header">
            <div className="table-cell">{Localization.translator.title}</div>
            <div className="table-cell">{Localization.translator.category}</div>
            <div className="table-cell">{Localization.translator.status}</div>
            <div className="table-cell">
              {Localization.translator.startDate}
            </div>
          </div>
          <div className="table-rows" onWheel={e => e.stopPropagation()}>
            {workflows.map((workflow, index) => (
              <div key={workflow.id || index} className="table-row">
                <div className="table-cell">{workflow.title}</div>
                <div className="table-cell">{workflow.categoryName}</div>
                <div className="table-cell">
                  <span
                    className={`status-badge status-${workflow.status?.toLowerCase()}`}
                  >
                    {workflow.status}
                  </span>
                </div>
                <div className="table-cell">
                  {new Date(workflow.startDate).toLocaleDateString()}
                </div>
              </div>
            ))}
            {workflows.length === 0 && (
              <div className="table-empty">
                {Localization.translator.dashboard.noWorkflowsFound}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div className={`widget-flip-container ${isFlipped ? 'flipped' : ''}`}>
      <div className="widget-flip-inner">
        {/* Front side */}
        <div className="widget-flip-front">{content}</div>

        {/* Back side */}
        <div className="widget-flip-back">
          <div className="widget metric-widget">
            <div className="widget-header">
              <span className="widget-title">{title}</span>
              <Button
                variant="ghost"
                size="icon"
                onClick={e => onFlip(widgetId, e)}
                onMouseDown={e => e.stopPropagation()}
                title={Localization.translator.dashboard.backToWidget}
              >
                <ArrowLeft />
              </Button>
            </div>
            <div className="widget-body widget-description">
              <p>{description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TableWidget
